(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-information-content"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-jsm-previous], [data-jsm-next]');
    if (!button) return;
    const section = button.closest('[data-jsm-testimonials]');
    const track = section && section.querySelector('[data-jsm-track]');
    const card = track && track.querySelector('.jsm-testimonial-card');
    if (!track || !card) return;
    const gap = Number.parseFloat(getComputedStyle(track).gap) || 0;
    const direction = button.hasAttribute('data-jsm-next') ? 1 : -1;
    track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
  });
  } catch(e) { console.error(e); }
})();

})();
